import type { ReactNode } from "react";

import { cn } from "../../utils/cn";

type ContentGridProps = {
  children: ReactNode;
  cols?: 2 | 3 | 4;
  spacing?: "sm" | "md" | "lg";
  className?: string;
};

const colsMap = {
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-2 lg:grid-cols-3",
  4: "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
};

const spacingMap = {
  sm: "gap-3",
  md: "gap-4",
  lg: "gap-6",
};

export function ContentGrid({
  children,
  cols = 3,
  spacing = "md",
  className,
}: ContentGridProps) {
  return (
    <div
      data-testid="content-grid"
      className={cn(
        "grid grid-cols-1",
        colsMap[cols],
        spacingMap[spacing],
        className,
      )}
    >
      {children}
    </div>
  );
}
